import { Reveal } from "./Reveal";
import { Blob, Dot } from "./Decor";

// Consistent interior-page hero with eyebrow + big title + decorative shapes.
export default function PageHero({ eyebrow, title, intro, index, accent = "#1A49F7" }) {
  return (
    <section className="relative overflow-hidden px-6 pb-16 pt-20 md:px-12 md:pb-24 md:pt-28">
      <Blob color="blue" className="-right-24 top-0" size={420} opacity={0.09} />
      <Blob color="orange" className="-left-24 bottom-0" size={320} opacity={0.08} />
      <span className="pointer-events-none absolute right-6 top-16 select-none text-[9rem] font-black leading-none text-[#EEF1FB] md:right-16 md:text-[16rem]">
        {index}
      </span>
      <div className="relative mx-auto max-w-7xl">
        <Reveal>
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em]" style={{ color: accent }}>
            <Dot color={accent} size={8} /> {eyebrow}
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h1 className="mt-5 max-w-4xl text-5xl font-black leading-[0.95] tracking-tighter text-[#14183A] md:text-7xl">
            {title}
          </h1>
        </Reveal>
        {intro && (
          <Reveal delay={0.16}>
            <p className="mt-8 max-w-2xl text-lg font-light leading-relaxed text-[#5b6072] md:text-xl">
              {intro}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
